export const CAR_RENTAL_SERVICE_ORDER_LINE_TYPE = "Aluguel de carro";
export const PERICIA_SERVICE_ORDER_LINE_TYPE = "Riparazione";
export const OTHERS_SERVICE_ORDER_LINE_TYPE = "Altro";

export const SERVICE_ORDER_LINE_TYPES = [
  CAR_RENTAL_SERVICE_ORDER_LINE_TYPE,
  PERICIA_SERVICE_ORDER_LINE_TYPE,
  OTHERS_SERVICE_ORDER_LINE_TYPE
];

export interface ServiceOrderLine {
  id: string;
  serviceOrderId: string;
  serviceOrderLineType: {
    id: string;
    name: string;
  };
  nuovautoClaimId: string;
  audatexClaimId: string;
  carRentalId: string;
  car?: {
    id: string;
    plate: string;
    chassisNumber: string;
    model: string;
    brand: string;
    color: string;
    insuranceName: string;
  };
  cost: number;
  discount: number;
  workHours: number;
  costByWorkHour: number;
  createdAt: Date;
  updatedAt: Date;
  createdBy: string;
  finished: boolean;
  description: string;
  billed: boolean;
  controlled: boolean;
}

export function CreateNewServiceOrderLine(override?: Partial<ServiceOrderLine>): ServiceOrderLine {
  return {
    id: "",
    serviceOrderId: "",
    serviceOrderLineType: {
      id: "",
      name: ""
    },
    nuovautoClaimId: "",
    audatexClaimId: "",
    carRentalId: "",
    car: {
      id: "",
      plate: "",
      chassisNumber: "",
      model: "",
      brand: "",
      color: "",
      insuranceName: ""
    },
    cost: 0,
    discount: 0,
    workHours: 0,
    costByWorkHour: 0,
    createdAt: new Date(),
    updatedAt: new Date(),
    createdBy: "",
    finished: false,
    description: "",
    billed: false,
    controlled: false,
    ...override
  };
}

export function calculateServiceOrderLineCost(workHours: number, costByWorkHour: number): number {
  return workHours * costByWorkHour || 0;
}

export function getServiceOrderLineBillingCost(line: Pick<ServiceOrderLine, "cost">): number {
  return line.cost || 0;
}

export function canBillServiceOrderLine(line: Pick<ServiceOrderLine, "billed" | "controlled" | "serviceOrderLineType">): boolean {
  if (line.billed) {
    return false;
  }

  if (line.serviceOrderLineType.name === PERICIA_SERVICE_ORDER_LINE_TYPE) {
    return line.controlled;
  }

  return true;
}

export function calculateServiceOrderLinesBillingTotal(lines: Array<Pick<ServiceOrderLine, "cost">>): number {
  return lines.reduce((sum, line) => sum + getServiceOrderLineBillingCost(line), 0);
}

export function GetServiceOrderLineTypeId(type: string): string | Error {
  switch (type) {
    case CAR_RENTAL_SERVICE_ORDER_LINE_TYPE:
      return "b08af134-30df-4364-884b-68a56cd81541";
    case PERICIA_SERVICE_ORDER_LINE_TYPE:
      return "331c2ef0-a585-4794-9426-a852636454c7";
    case OTHERS_SERVICE_ORDER_LINE_TYPE:
      return "03c45a2f-cb3a-4f1e-9c64-1b344e4cd52f";
    default:
      return new Error(`Unknown service order line type: ${type}`);
  }
}
